import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import { Box, Grid } from "@material-ui/core";
import theme from "theme";
import translateIntl from "i18n/translateIntl";
import translate from "i18n/translate";
import { getFormValidationScheme, inputShouldBeRendered } from "./constants";
import { useStyles } from "../applicationStyles";
import { SrAlert, SrButton, SrInput, Typography } from "../../../../common";
import ApplicationSquareButton from "../ApplicationSquareButton";

const CreateForm = ({ form, resetForm, onSubmit, error }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Box
        display="flex"
        width="100%"
        flexDirection="column"
        alignItems="center"
      >
        <Box marginY={5}>
          <Typography variant="h4Regular">
            {translate("applications.initialConfig")}
          </Typography>
        </Box>
        <ApplicationSquareButton
          className={classes.squareIcon}
          applicationType={form.platform}
          bgcolor={theme.palette.buttonPrimary.main}
        />
      </Box>
      <Grid item xs={12}>
        <Box maxWidth="356px" marginX="auto">
          <Formik
            initialValues={form}
            validationSchema={getFormValidationScheme(form.platform)}
            onSubmit={onSubmit}
          >
            {({
              errors,
              handleSubmit,
              handleBlur,
              handleChange,
              touched,
              values,
              isSubmitting,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Box mb={4}>
                  <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Grid container item spacing={2} direction="column">
                      {Object.keys(form).map((key) => {
                        if (inputShouldBeRendered(key)) {
                          return (
                            <Grid item xs={12}>
                              <SrInput
                                type="text"
                                name={key}
                                key={key}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                label={translateIntl(
                                  `applications.newApp.form.${key}`
                                )}
                                placeholder={translateIntl(
                                  `applications.newApp.form.${key}Placeholder`
                                )}
                                value={values[key]}
                                error={errors[key] && touched[key]}
                                helperText={touched[key] && errors[key]}
                                fullWidth
                              />
                            </Grid>
                          );
                        }
                        return undefined;
                      })}
                      {error && (
                        <Grid item xs={12}>
                          <SrAlert severity="error">{error}</SrAlert>
                        </Grid>
                      )}
                      <Grid item container xs={12} spacing={2}>
                        <Grid item>
                          <SrButton
                            type="submit"
                            variant="contained"
                            disabled={isSubmitting}
                            color="primary"
                          >
                            {translate("common.register")}
                          </SrButton>
                        </Grid>
                        <Grid item>
                          <SrButton
                            onClick={resetForm}
                            padding={4}
                            disabled={isSubmitting}
                          >
                            {translate("common.cancel")}
                          </SrButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Grid>
    </Grid>
  );
};

CreateForm.propTypes = {
  form: PropTypes.shape({
    applicationName: PropTypes.string,
    applicationBundle: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  resetForm: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
};

CreateForm.defaultProps = {
  error: null,
};

export default CreateForm;
